// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  android_version: '3', // debe ser la misma que en android studio y la misma que en el parametro global
  android_url: 'https://play.google.com/store/apps/details?id=com.core.enmovimientofitnessestudio',
    ios_url: 'https://apps.apple.com/es/app/en-movimiento-fitness-estudio/id6758141517',
    // api: 'http://localhost:8000/api/',
     api: 'https://gestion.enmovimientofitnessestudio.com/api/',
    firebaseConfig: {
        apiKey: "AIzaSyCsHRh8QGTrQfoSee2J9C0y0xLFUJeiPPA",
        authDomain: "en-movimiento-fitness-estudio.firebaseapp.com",
        projectId: "en-movimiento-fitness-estudio",
        storageBucket: "en-movimiento-fitness-estudio.firebasestorage.app",
        messagingSenderId: "1444212430",
        appId: "1:1444212430:web:41d291041a345920a8ea9f",
        measurementId: "G-V28G7VDPRE"
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
